import React from "react";
import { Text } from "react-native";

const VText = (props) => {


    

    return (
        <Text
            {...props}
            style={[
                {
                    fontFamily: "JosefinSans",
                    fontWeight: "350",
                    lineHeight: "120%",
                    color: "#212427",
                    ...(!Array.isArray(props?.style) ? props?.style : {}),
                },
                ...(Array.isArray(props?.style) ? props?.style : []),
            ]}
        >
            
            {props.text}
            {props.children}
        </Text>
    );
};

export default VText;
